import { crearWhatsAppUrl } from '../../../utils/contactos';

export const createWhatsAppUrl = (message = '') =>
  crearWhatsAppUrl('canal', message || '');

export const canalWhatsAppMessages = {
  create:
    'Hola, quiero crear un canal propio para mi organización.',
  technical:
    'Hola, quiero conocer el acompañamiento técnico para crear un canal propio.',
};
